// import { Alert } from "components/Alert/Alert";
// import { useLangContext } from "components/Lang/Lang";
// import { Loading } from "components/Loading/Loading";
// import {  Geometry, GeometryTypes } from "components/ThreeItems/Geometry/Geometry";
// import { SceneItemsType } from "components/ThreeItems/Scene";
import { Geometry } from "components/ThreeItems/Geometry/Geometry";
import { avatarParts } from "components/ThreeItems/VRPlayer/avatar-player";
import { useLangContext } from "context/Lang";
import { ToastMessage } from "primereact/toast";
import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { routes } from "routes";
import { AsyncProcess } from "services/AsyncProcess";
import { setToast } from "storeRedux/slices/toast";
import * as THREE from "three"
import { rgbToHex } from "utils/color/rgbToHex";
import { ReplaceWords } from "utils/ReplaceWords";
// import { ColorsType, ObjectType } from "types";
// import { CategoriObjectProps,  MapItemProps, MaterialTypeProps } from "types/three";
// import { rgbToHex } from "utils/rgbToHex";
import { StringJSONPRS } from "utils/StringJsonPRS";






type meshFunProcess = ({ ...e }: { mesh: THREE.Object3D, copy?: boolean, effect?: () => void }) => void




export interface AvatarEditorContextProps {

    meshes?: MeshProps[],
    handleLoadScene?: (e: SceneItemsProps,onDataLoad?:(e:THREE.Group)=>void) => void

}


const AvatarEditorContext = createContext<AvatarEditorContextProps>({});

const geometryCache = new Map<string, THREE.BufferGeometry>();
const materialCache = new Map<string, THREE.Material>();


type AvatarEditorProviderProps = {
    onDataLoad?: (e?: any) => void,
    children: any,
    editorId?: number
}

export const AvatarEditorProvider = ({ ...props }: AvatarEditorProviderProps) => {



    // const [alert,setAlert]=useState<{color?:ColorsType,message:string}|null>(null);


    const sceneItemsRef = useRef<SceneItemsProps | undefined>(undefined);

    const { gW } = useLangContext();

    // const [selectMesh, setSelectMesh] = useState<THREE.Object3D | null>(null);

    // const [cards,setCards]=useState<CategoriObjectProps[]|null>(null);
    // const [category,setCategory]=useState<CategoriObjectProps[]|null>(null);

    const meshes = avatarParts ; 
    const [searchParams] = useSearchParams();

    const editorId = props?.editorId || searchParams.get("editorId");

    const [block, setBlock] = useState<boolean>(false);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            geometryCache.forEach(g => g.dispose());
            materialCache.forEach(m => m.dispose());
            geometryCache.clear();
            materialCache.clear();
        };
    }, [editorId]);


    
    

    const addMesh = ({ mesh, isSelect = true }: { mesh?: MeshProps, isSelect?: boolean }): void => {
        if (!sceneItemsRef.current?.scene_group) return;

        // توليد مفاتيح الكاش الفريدة بناءً على خصائص العنصر
        const geoKey = `${mesh?.type}_${mesh?.radialSegments || 'default'}_${JSON.stringify(mesh?.parameters || {})}`;
        const matKey = `${mesh?.color || '#ffffff'}_${mesh?.material?.imageUrl || 'none'}_${mesh?.opacity || 1}`;
        let finalObject: THREE.Object3D;

        // 2. استخدام الماتيريال والجيومتري من الكاش أو إنشائهم إذا لم يتواجدوا
        let sharedGeometry = geometryCache.get(geoKey);
        let sharedMaterial = materialCache.get(matKey);



        const temp = Geometry({
            type: mesh?.type,
            parameters: mesh?.parameters,
            material: { color: mesh?.color, imageUrl: mesh?.material?.imageUrl as string   || null, opacity: Number(mesh?.opacity || 1) }
        });

        if (!sharedGeometry) {
            sharedGeometry = temp.mesh.geometry;
            geometryCache.set(geoKey, sharedGeometry);
        }

        if (!sharedMaterial) {
           
            sharedMaterial = temp.mesh.material as THREE.Material;
            materialCache.set(matKey, sharedMaterial);
        }


      
        finalObject = new THREE.Mesh(sharedGeometry, sharedMaterial);
        finalObject.userData={...temp.mesh.userData}



        
        
        const prs = mesh?.prs ? StringJSONPRS({ data: mesh?.prs + "" }) as any : {};
        const [px, py, pz] = prs.position|| mesh?.position  || [0, 0, 0];
        finalObject.position.set(px, py, pz);

        const [rx, ry, rz] = prs.rotation||mesh?.rotation || [0, 0, 0];
        finalObject.rotation.set(rx, ry, rz);

        const [sx, sy, sz] = prs.scale|| mesh?.scale || [1, 1, 1];
        finalObject.scale.set(sx, sy, sz);

        finalObject.name = mesh?.name || "Unnamed Mesh";
        
        finalObject.userData = {
            ...finalObject.userData,
            id: mesh?.id,
            type: mesh?.type,
            materialId: mesh?.material?.id,
            imageUrl: mesh?.material?.imageUrl,
            isLOD: finalObject instanceof THREE.LOD,
        };


        sceneItemsRef.current.scene_group.add(finalObject);
    };


    const loadMeshes = (meshes?: MeshProps[],onDataLoad?:(e:THREE.Group)=>void) => {

    
        if (sceneItemsRef?.current?.scene_group && meshes) {
            sceneItemsRef.current.scene_group.children = [];
            meshes?.forEach(mesh => {
                addMesh?.({ mesh, isSelect: false });
            })

            onDataLoad?.(sceneItemsRef.current.scene_group);

            props.onDataLoad?.();
        }
    }


    // useEffect(()=>{
    //     setMeshes([]);
    //     return ()=>{
    //         setMeshes([]);
    //     }
    // },[pathname]);


    const handleLoadScene = (e: SceneItemsProps,onDataLoad?:(e:THREE.Group)=>void): void => {
        sceneItemsRef.current = e;
        loadMeshes(meshes,(e)=>{
            onDataLoad?.(e);
        });

    }



    // const getMaterials=()=>{
    //     setBlock(true);   
    //     AsyncProcess({
    //         type:"get",
    //         url:routes.api.material,
    //         setError:(err)=>{
    //             setAlert({message:gW(err?.error||"happen-error"),color:"red"})
    //             setBlock(false);
    //         },
    //         effectProcess:[(res)=>{
    //             setMaterials(res.map((r:any)=>({...r,image: r?.image?(process.env.REACT_APP_API_URL||"")+r?.image:""})));    
    //             setBlock(false);
    //         }]
    //     });



    // }






    useEffect(() => {
        if (editorId) {
      
        }
    }, [editorId])





    const values: AvatarEditorContextProps = {
        meshes,

       
        handleLoadScene,
    }

    return (<AvatarEditorContext.Provider value={values}>
        {/* {alert&&<Alert color={alert.color} open={alert!==null} onClose={()=>setAlert(null)}  messages={[<p key={1} > {alert.message} </p>]} />} */}
        {props.children}
        {/* {block&&<Loading/>} */}
    </AvatarEditorContext.Provider>)
}



export const useAvatarEditorContext = () => useContext<AvatarEditorContextProps>(AvatarEditorContext);